<template>
    <div>
        <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="invoiceInfo_tooltip_NAME"  :name="invoiceInfo_tooltip_NAME" :description="invoiceInfo_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
    <div class='container-invoice'>
        <div class="row">
            <div class="col-sm-6">
                <label for="name">Invoice Number</label>
                <base-input
                id="invoice number"
                :disabled="isReadOnly || isPartnerAccount"
                data-vv-as="invoice number"
                v-model="invoiceInformation.invoiceNumber"
                name="invoicenumber"
                >
                </base-input>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 content_padding_top">
                <div class="pull-right">
                <base-button
                    type="primary"
                    :disabled="isReadOnly || isPartnerAccount"
                    wide
                    @click.native="submit"
                    class="btn-next"
                    >Save</base-button
                >
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import Util from '../../../../../util/util';
    import toolTip  from "../../../Tooltip";

    export default {
        props: ["isReadOnly"],
        name: "InvoiceInformation",
        components: {
          toolTip
         },
        data() {
            return {
                invoiceInfo_tooltip_NAME : '',
                invoiceInfo_tooltip_DESCRIPTION : '',
                };
            },
            async mounted() {
            await this.getAllTooltips()
            this.loadToolTips()
            },
        computed: {
            ...mapGetters({
                invoiceInformation: "invoiceInformation/invoiceInformation",
                isPartnerAccount: "authentication/isPartnerAccount",
                toolTips: "tooltip/tooltips",
                editable: "tooltip/editable"
            }),
            getOrderIdFromRoute() {
                return parseInt(this.$route.params.id);
            },
        },
        methods: {
            ...mapActions({
                saveInvoiceNumber: "invoiceInformation/saveInvoiceNumber",
                loadInvoiceInformation: "invoiceInformation/loadInvoiceInformation",
                getAllTooltips: "tooltip/getToolTips"
            }),
            loadToolTips(){
                const invoiceInfoVal = this.toolTips.find(e => e.name === "InvoiceInformationModule")
                if(invoiceInfoVal && invoiceInfoVal.status){
                this.invoiceInfo_tooltip_DESCRIPTION = invoiceInfoVal.description ? invoiceInfoVal.description: null
                this.invoiceInfo_tooltip_NAME = invoiceInfoVal.name ? invoiceInfoVal.name: null
                }
                return 
                
                },
            updateToolTip(updatedData){
                this.loadToolTips()
            },
            async submit() {
               let ret = await this.saveInvoiceNumber(this.$route.params.id);
               if(!Util.isNullOrEmpty(ret)) {
                   this.$toast.error(ret);
               }
            },
            loaded() {
                let ctx = this;
                ctx.loadInvoiceInformation(ctx.getOrderIdFromRoute);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container-invoice {
        button {
            margin-top: 25px;
        }
    }
</style>
